import { api } from "@/lib/api";

export const MixboardAPI = {
  createSession: (payload: any) => api.post(`/design/mixboard/session`, payload),
  getSession: (id: string) => api.get(`/design/mixboard/session/${id}`),
  updateLayer: (id: string, data: any) => api.patch(`/design/mixboard/layers/${id}`, data),
  addLayer: (sid: string, data: any) => api.post(`/design/mixboard/session/${sid}/layers`, data),
  reorderLayers: (sid: string, order: string[]) =>
    api.post(`/design/mixboard/session/${sid}/layers/reorder`, { order }),
  listTemplates: () => api.get(`/design/mixboard/templates`),
  loadTemplate: (id: string) => api.get(`/design/mixboard/templates/${id}`),
  generate: (sid: string, draft = false) =>
    api.post(`/design/mixboard/generate`, undefined, {
      params: { session_id: sid, draft },
    }),
  multiGenerate: (sid: string) =>
    api.post(`/design/mixboard/multi-generate`, undefined, { params: { session_id: sid } }),
  uploadReference: (sid: string, file: File) => {
    const formData = new FormData();
    formData.append("file", file);
    return api.upload(`/design/mixboard/session/${sid}/references/upload`, formData);
  },
  listReferences: (sid: string) => api.get(`/design/mixboard/session/${sid}/references`),
  solveLayout: (sid: string) => api.post(`/design/mixboard/session/${sid}/solve-layout`, {}),
  compose: (sid: string, payload?: any) => api.post(`/design/mixboard/session/${sid}/compose`, payload ?? {}),
  refine: (sid: string, instruction: string) =>
    api.post(`/design/mixboard/session/${sid}/refine`, { instruction }),
  undo: (sid: string) => api.post(`/design/mixboard/session/${sid}/undo`, {}),
  redo: (sid: string) => api.post(`/design/mixboard/session/${sid}/redo`, {}),
  saveVersion: (sid: string, name: string) => api.post(`/design/mixboard/session/${sid}/versions`, { name }),
  listVersions: (sid: string) => api.get(`/design/mixboard/session/${sid}/versions`),
  restoreVersion: (sid: string, versionId: string) =>
    api.post(`/design/mixboard/session/${sid}/versions/${versionId}/restore`, {}),
  exportPrint: (
    imageUrl: string,
    params?: { dpi?: number; bleed?: number; simulate_cmyk?: boolean },
  ) =>
    api.post(
      `/design/mixboard/export/print`,
      undefined,
      {
        params: { image_url: imageUrl, ...(params ?? {}) },
      },
    ),
  buildTypography: (sid: string) => api.post(`/design/mixboard/session/${sid}/typography/build`, {}),
  deleteLayer: (layerId: string) => api.delete(`/design/mixboard/layers/${layerId}`),
  createExportJob: (sid: string, body: any) => api.post(`/design/mixboard/session/${sid}/export/jobs`, body),
  getExportStatus: (taskId: string) => api.get(`/design/mixboard/export/jobs/${taskId}`),
};
